import { api } from "./urlApi";

export const getPuestosByCeremonia = async (tipo_misa) => {
  const url = `${api}/puestos/getByTipoCeremonia.php?tc=${tipo_misa}`;

  const resp = await fetch(url);
  const puestos = await resp.json();

  return puestos;
};

export const getPuestosByAcolito = async (id_acolito) => {
  const url = `${api}/puestos/getByAcolito.php?id=${id_acolito}`;

  try {
    const resp = await fetch(url);
    const puestos = await resp.json();
    return puestos;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const getPuestos = async () => {
  const url = `${api}/puestos/get.php`;

  try {
    const resp = await fetch(url);
    const puestos = await resp.json();
    return puestos;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//POST

export const addPuestos = async (puestos, idAcolito) => {
  const url = `${api}/puestos/addPuestosByAcolito.php?id=${idAcolito}`;

  try {
    const resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(puestos),
    });

    return resp;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//PUT

export const updatePuesto = async (puesto, idAcolito) => {
  const url = `${api}/puestos/updatePuestosByAcolito.php?id=${idAcolito}`;

  try {
    const resp = await fetch(url, {
      method: "PUT",
      body: JSON.stringify(puesto),
    });

    return resp;
  } catch (error) {
    console.error(error);
    return false;
  }
};
